module.exports = __webpack_public_path__ + "static/media/ruler-triangle.2807f982.svg";